export const APP_BASE_ROUTE = '';
export const APP_ROUTES = {
    INTRO: '',
    HOME: '/home',
    RATING: '/rating',
    FRIENDS: '/friends',
    GAME: '/play',
};